import {CtPage} from './ct-page';
import {CtImage} from './ct-image';
import {Language} from './language';
import {construct, createInstance, ModelProperties} from '../utils';

export class CtPageImage {
    id!: number;

    pageId!: number;

    imageId!: number;

    languageId?: number | null;

    page?: CtPage;

    image?: CtImage;

    language?: Language;

    constructor(pageImage?: ModelProperties<CtPageImage>) {
        if (pageImage) {
            construct(this, pageImage);
            this.page = createInstance(CtPage, pageImage.page);
            this.image = createInstance(CtImage, pageImage.image);
            this.language = createInstance(Language, pageImage.language);
        }
    }
}